var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-left":"350px","padding-right":"350px"}},[_c('v-img',{attrs:{"src":_vm.logo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }